const changeHistorySagaNamespace = 'changeHistory';
export const LOAD_CHANGE_HISTORY = `${changeHistorySagaNamespace}/LOAD_CHANGE_HISTORY`;
